import {
  Table,
  TableBody,
  TableHeader,
  TableHead,
  TableRow,
  TableCell
} from '@/components/ui/table';
import { Card } from '@/components/ui/card';
import { useSalesSiteLeads } from '@/data/salessiteLead';
import { convertToDateFormat } from '@/helpers/dateHelpers';

import NotFound from '@/components/common/NotFound';

const SalesSiteLeadList = () => {
  const salesSiteLeads = useSalesSiteLeads();

  if (salesSiteLeads.data.length === 0) {
    return <NotFound title="No Sales Site Leads Found" />;
  }

  return (
    <>
      <Card>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Name</TableHead>
              <TableHead>Email</TableHead>
              <TableHead>Message</TableHead>
              <TableHead>Created At</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {salesSiteLeads.data.map((lead) => (
              <TableRow key={lead.id}>
                <TableCell>{lead.name}</TableCell>
                <TableCell>{lead.email}</TableCell>
                <TableCell>{lead.message}</TableCell>
                <TableCell>{convertToDateFormat(lead.createdAt)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
      <div className="text-center p-4">
        <span className="text-sm text-muted-foreground">
          Total: {salesSiteLeads.data.length}
        </span>
      </div>
    </>
  );
};

export default SalesSiteLeadList;
